



export const QUERY_PARAM_LOGIN_TYPE = "QUERY_PARAM_LOGIN_TYPE";
export const QUERY_PARAM_USER_EMAIL = "QUERY_PARAM_USER_EMAIL";
export const QUERY_PARAM_USER_NICKNAME = "QUERY_PARAM_USER_NICKNAME";


export const updateQueryLoginType = param1 => {
  return{
    type: QUERY_PARAM_LOGIN_TYPE,
    payload: param1
  }
}

export const updateQueryUserEmail = param1 => {
  return{
    type: QUERY_PARAM_USER_EMAIL,
    payload: param1
  }
}

export const updateQueryUserNickname = param1 => {
  return{
    type: QUERY_PARAM_USER_NICKNAME,
    payload: param1
  }
}


export const QUERY_PATIENT_NAME = "QUERY_PATIENT_NAME";
export const QUERY_PATIENT_ROOM_NAME = "QUERY_PATIENT_ROOM_NAME";

export const updateQueryPatientName = param1 => {
  return {
    type: QUERY_PATIENT_NAME,
    payload: param1
  }
}

export const updateQueryPatientRoomName = param1 => {
  return {
    type: QUERY_PATIENT_ROOM_NAME,
    payload: param1
  }
}


//긴급/주의 이력 조회
export const QUERY_PARAM_START_DATE = "QUERY_PARAM_START_DATE";
export const QUERY_PARAM_START_TIME = "QUERY_PARAM_START_TIME";
export const QUERY_PARAM_END_DATE = "QUERY_PARAM_END_DATE";
export const QUERY_PARAM_END_TIME = "QUERY_PARAM_END_TIME";
export const QUERY_PARAM_EMERGENCY_ROOMID = "QUERY_PARAM_EMERGENCY_ROOMID";
export const QUERY_PARAM_CHECK_EMERGENCY = "QUERY_PARAM_CHECK_EMERGENCY";
export const QUERY_PARAM_CHECK_CAUTION = "QUERY_PARAM_CHECK_CAUTION";
export const QUERY_PARAM_CHECK_COMPLETED = "QUERY_PARAM_CHECK_COMPLETED";


export const updateQueryStartDate = param1 => {
  return {
    type: QUERY_PARAM_START_DATE,
    payload: param1
  }
}

export const updateQueryStartTime = param1 => {
  return {
    type: QUERY_PARAM_START_TIME,
    payload: param1
  }
}

export const updateQueryEndDate = param1 => {
  return {
    type: QUERY_PARAM_END_DATE,
    payload: param1
  }
}

export const updateQueryEndTime = param1 => {
  return {
    type: QUERY_PARAM_END_TIME,
    payload: param1
  }
}

export const updateQueryEmergencyRoomId = param1 => {
  return {
    type: QUERY_PARAM_EMERGENCY_ROOMID,
    payload: param1
  }
}

export const updateQueryCheckEmergency = param1 => {

  return {
    type: QUERY_PARAM_CHECK_EMERGENCY,
    payload: param1
  }
}

export const updateQueryCheckCaution = param1 => {

  return {
    type: QUERY_PARAM_CHECK_CAUTION,
    payload: param1
  }
}


export const updateQueryCheckCompleted = param1 => {
  return {
    type: QUERY_PARAM_CHECK_COMPLETED,
    payload: param1
  }
}


//기상/재실 이력 조회
export const QUERY_PARAM_WAKEUP_START_DATE = "QUERY_PARAM_WAKEUP_START_DATE";
export const QUERY_PARAM_WAKEUP_START_TIME = "QUERY_PARAM_WAKEUP_START_TIME";
export const QUERY_PARAM_WAKEUP_ROOMID = "QUERY_PARAM_WAKEUP_ROOMID";
export const QUERY_PARAM_CHECK_WAKEUP = "QUERY_PARAM_CHECK_WAKEUP";
export const QUERY_PARAM_CHECK_PRESENCE = "QUERY_PARAM_CHECK_PRESENCE";


export const updateQueryWakeupStartDate = param1 => {
  return {
    type: QUERY_PARAM_WAKEUP_START_DATE,
    payload: param1
  }
}

export const updateQueryWakeupStartTime = param1 => {
  return {
    type: QUERY_PARAM_WAKEUP_START_TIME,
    payload: param1
  }
}

export const updateQueryWakeupRoomId = param1 => {
  return {
    type: QUERY_PARAM_WAKEUP_ROOMID,
    payload: param1
  }
}

export const updateQueryCheckWakeup = param1 => {

  return {
    type: QUERY_PARAM_CHECK_WAKEUP,
    payload: param1
  }
}

export const updateQueryCheckPresence = param1 => {

  return {
    type: QUERY_PARAM_CHECK_PRESENCE,
    payload: param1
  }
}



//-------------------------------------------------
//센서디바이스 쿼리

/** 센서ID */
export const QUERY_SENSOR_QUERY_SENSORID = "QUERY_SENSOR_QUERY_SENSORID";
/** 센서 설치위치 */
export const QUERY_SENSOR_QUERY_INSTALLED = "QUERY_SENSOR_QUERY_INSTALLED";
// /** 센서 환자 */
// export const QUERY_SENSOR_QUERY_PATIENT = "QUERY_SENSOR_QUERY_PATIENT";

export const updateSensorQuerySensorId = param1 => {
  return {
    type: QUERY_SENSOR_QUERY_SENSORID,
    payload: param1
  }
}

export const updateSensorQueryInstalled = param1 => {
  return {
    type: QUERY_SENSOR_QUERY_INSTALLED,
    payload: param1
  }
}

// export const updateSensorQueryPatientName = param1 => {
//   return {
//     type: QUERY_SENSOR_QUERY_PATIENT,
//     payload: param1
//   }
// }


//-------------------------------------------------
//룸 쿼리

/** 룸 ID */
export const ROOM_QUERY_ROOM_ID = "ROOM_QUERY_ROOM_ID";
/** 룸 명칭 */
export const ROOM_QUERY_ROOM_NAME = "ROOM_QUERY_ROOM_NAME";

export const updateQueryRoomId = param1 => {
  return {
    type: ROOM_QUERY_ROOM_ID,
    payload: param1
  }
}

export const updateQueryRoomName = param1 => {
  return {
    type: ROOM_QUERY_ROOM_NAME,
    payload: param1
  }
}


//-------------------------------------------------
//요양사 쿼리

/** 요양사 이름 */
export const QUERY_CAREGIVER_NAME = "QUERY_CAREGIVER_NAME";

export const updateCaregiverName = param1 => {
  return {
    type: QUERY_CAREGIVER_NAME,
    payload: param1
  }
}


//-------------------- 앱 계정 쿼리

export const QUERY_AUTH_AUTHID = "QUERY_AUTH_AUTHID";

export const updateQueryAuth_AuthID = param1 => {
  return {
    type: QUERY_AUTH_AUTHID,
    payload: param1
  }
}

export const QUERY_AUTH_FACILITY_NAME = "QUERY_AUTH_FACILITY_NAME";
export const updateQueryAuth_FacilityName = param1 => {
  return {
    type: QUERY_AUTH_FACILITY_NAME,
    payload: param1
  }
}

